import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const arrowVariants = {
  small: { viewBox: '0 0 8 8', path: 'M1 7L7 1M7 1H1M7 1V7', strokeWidth: 1 },
  button: { viewBox: '0 0 13 13', path: 'M2 11L12 1M12 1H2M12 1V11', strokeWidth: 2 },
  default: { viewBox: '0 0 15 15', path: 'M2 13L14 1M14 1H2M14 1V13', strokeWidth: 1.54687 },
} as const;

export function ArrowUpRightIcon({
  size = 'default',
  ...props
}: IconProps & { size?: keyof typeof arrowVariants }) {
  const variant = arrowVariants[size];
  return (
    <svg
      width="100%"
      height="100%"
      viewBox={variant.viewBox}
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path
        d={variant.path}
        stroke="currentColor"
        strokeWidth={variant.strokeWidth}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowUpLeftIcon(props: IconProps) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 15 15" fill="none" aria-hidden="true" {...props}>
      <path
        d="M13 13L0.999999 1M0.999999 1L1 13M0.999999 1L13 0.999999"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckIcon(props: IconProps) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M20 6L9 17L4 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AlertIcon(props: IconProps) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
